module.exports = __webpack_public_path__ + "static/img/16.1bc38b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/eng/16.png
// module id = ykrp
// module chunks = 0